import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { useLanguageContext } from '@/i18n/LanguageContext';
import { moreDetails } from '@/mocks/pricingData';

export default function MoreDetails() {
  const { t } = useTranslation();
  const { lang } = useLanguageContext();
  return (
    <section className="relative py-20 md:py-28 bg-background-50">
      <div className="max-w-[800px] mx-auto px-8">
        <div className="text-center mb-14">
          {String(t('pricing.more.label')).split(/\n{2,}/).map((__s, __i) => (<p key={__i} className="text-accent-600 text-[13px] tracking-[0.2em] mb-5 font-label">{__s}</p>))}
          <h2 className="font-heading text-xl md:text-2xl text-foreground-900 tracking-[0.06em] mb-2">
            {t('pricing.more.title')}
          </h2>
          {String(t('pricing.more.titleEn')).split(/\n{2,}/).map((__s, __i) => (<p key={__i} className="section-title-en text-accent-500 text-[15px] tracking-[0.12em] mb-4">{__s}</p>))}
          <div className="gold-line mx-auto"></div>
        </div>

        <div className="flex flex-col lg:flex-row gap-10 lg:gap-14 items-start">
          <div className="lg:w-[45%] w-full">
            <div className="w-full h-[240px] md:h-[280px] overflow-hidden">
              <img
                src="/images/generated/pricing-more-2026.jpg"
                alt={t('pricing.more.imgAlt')}
                className="w-full h-full object-cover object-top"
              />
            </div>
            {String(t('pricing.more.imgCaption')).split(/\n{2,}/).map((__s, __i) => (<p key={__i} className="text-[13px] text-foreground-500 tracking-[0.04em] mt-3 text-center">{__s}</p>))}
          </div>

          <div className="lg:w-[55%]">
            {String(t('pricing.more.lead')).split(/\n{2,}/).map((__s, __i) => (<p key={__i} className="text-[15px] md:text-[16px] text-foreground-600 tracking-[0.04em] leading-relaxed mb-8">{__s}</p>))}

            <div className="space-y-3">
              {moreDetails.map((item, idx) => (
                <Link
                  key={idx}
                  to={item.href}
                  className="card-glow group flex items-center justify-between p-4 border border-background-200/60 bg-background-100/50 cursor-pointer"
                >
                  <div>
                    <h3 className="text-[16px] text-foreground-800 tracking-[0.05em] group-hover:text-accent-600 transition-colors">
                      {lang === 'en' ? t(`pricing.moreDetails.${idx}.title`) : item.title}
                    </h3>
                    <p className="text-[14px] text-foreground-500 tracking-[0.03em] mt-0.5">
                      {lang === 'en' ? t(`pricing.moreDetails.${idx}.desc`) : item.description}
                    </p>
                  </div>
                  <div className="w-5 h-5 flex items-center justify-center flex-shrink-0 ml-4">
                    <i className="ri-arrow-right-s-line text-accent-500 text-sm group-hover:text-accent-400 transition-colors"></i>
                  </div>
                </Link>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
